var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgMenu = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 30,
  height: 23,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M.75 22.27v-3.712h28.5v3.712H.75Zm0-9.28V9.28h28.5v3.712H.75Zm0-9.278V0h28.5v3.712H.75Z",
  fill: "#1C1B1F"
})));
export { SvgMenu as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzAiIGhlaWdodD0iMjMiIHZpZXdCb3g9IjAgMCAzMCAyMyIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTAuNzUgMjIuMjY5NlYxOC41NThIMjkuMjVWMjIuMjY5NkgwLjc1Wk0wLjc1IDEyLjk5MDZWOS4yNzg5OUgyOS4yNVYxMi45OTA2SDAuNzVaTTAuNzUgMy43MTE1OVYwSDI5LjI1VjMuNzExNTlIMC43NVoiIGZpbGw9IiMxQzFCMUYiLz4KPC9zdmc+Cg==";